import React from 'react';
import PropTypes from 'prop-types';

import hoistNonReactStatics from 'hoist-non-react-statics';
import {connect} from 'react-redux';

import ChannelPrice from './ChannelPrice';
import ChannelLink from './ChannelLink';

export default function withChannelFormatters(WrappedComponent) {
  const enhancer =  connect(({channels}) => ({
    activeChannel: channels.activeChannel,
    currency: (channels.activeChannel && channels.availableChannels) && channels.availableChannels[channels.activeChannel].baseCurrency
  }), {})(function channelFormatters({activeChannel, currency, ...rest}) {
    return <WrappedComponent
      channelFormatters={{
        link: (path) => ChannelLink.formatLink(activeChannel, path),
        price: (price) => ChannelPrice.formatPrice(currency, price),
        currencyCode: () => ChannelPrice.formatCurrencyCode(currency),
        currencySymbol: () => ChannelPrice.formatCurrencySymbol(currency)
      }}
      {...rest}
    />
  });

  return hoistNonReactStatics(enhancer, WrappedComponent);
}



// WEBPACK FOOTER //
// ./containers/channelUtils/withChannelFormatters.js